import React from 'react';
import { motion } from 'framer-motion';
export function LeadershipReadiness() {
  return <section className="py-24 lg:py-32 px-4 sm:px-6 lg:px-8 bg-[#0F3050] text-white" data-id="element-913">
      <div className="max-w-4xl mx-auto text-center" data-id="element-914">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-915">
          <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-6 block" data-id="element-916">
            Leadership Readiness
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold mb-8 leading-tight" data-id="element-917">
            Better leadership should be built, not assumed
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-surface-muted/80 leading-relaxed text-left md:text-center mb-12" data-id="element-918">
            <p data-id="element-919">
              As responsibility increases, the framework becomes more rigorous.
              For civil servants and senior officials, the focus shifts toward
              integrity, systems thinking, judgment under pressure, and
              institutional responsibility.
            </p>
            <p data-id="element-920">
              For ministers, governors, prime ministers, presidents, and
              executive leadership, it expands into crisis reasoning, escalation
              management, consequence modeling, misinformation handling, and
              governance stability.
            </p>
          </div>

          <div className="inline-block border-t border-white/20 pt-8" data-id="element-921">
            <p className="text-xl md:text-2xl font-heading font-medium text-white" data-id="element-922">
              Leadership should be treated as a capability domain,{' '}
              <br className="hidden md:block" data-id="element-923" />
              not merely a branding exercise.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}